// Maps the six steps onto the quiz events the ecom analytics module already
// defines (lib/analytics/events.ts). The event names predate this sheet and are
// shared with the legacy quiz, so dashboards keep working across both.

import { quizQuestionPage } from '../../lib/analytics/events';
import { StepId } from './steps';

const PAGE_ENTERED: Record<StepId, () => void> = {
  age: quizQuestionPage.quizPetAgePageEntered,
  size: quizQuestionPage.quizPetSizePageEntered,
  residence: quizQuestionPage.quizPetLocationPageEntered,
  exercise: quizQuestionPage.quizPetTellUsMorePageEntered,
  importance: quizQuestionPage.quizWhatsImportantToYouPageEntered,
  email: quizQuestionPage.quizEnterEmailPageEntered,
};

const ANSWERED: Record<StepId, (answer: string) => void> = {
  age: quizQuestionPage.quizPetAgeNext,
  size: quizQuestionPage.quizPetSizeNext,
  residence: quizQuestionPage.quizPetLocationNext,
  exercise: quizQuestionPage.quizTellUsMoreNext,
  importance: quizQuestionPage.quizWhatsImportantToYouNext,
  email: quizQuestionPage.quizEnterEmailNext,
};

export function trackStepEntered(stepId: StepId): void {
  PAGE_ENTERED[stepId]();
}

/** Multi-select answers go out comma-joined, matching the legacy quiz's shape. */
export function trackStepAnswered(stepId: StepId, answer: string | string[] | null): void {
  ANSWERED[stepId](Array.isArray(answer) ? answer.join(', ') : (answer ?? ''));
}

export function trackEmailSkipped(): void {
  quizQuestionPage.quizEnterEmailSkipped();
}
